import React from 'react';

function MultiTagModal({
  editingResource,
  editingResourceTags,
  tags,
  resourceSaving,
  toggleEditingTag,
  saveMultiTagEditing,
  onClose,
}) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="p-6 border-b">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="text-lg font-semibold">編輯權限標籤</h3>
              <p className="text-sm text-gray-500 mt-1">
                {editingResource.type === 'projects' && '專案：'}
                {editingResource.type === 'reports' && '報表：'}
                <span className="font-medium text-gray-700">{editingResource.resource.name}</span>
              </p>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Modal Body */}
        <div className="p-6 max-h-[60vh] overflow-y-auto">
          <p className="text-sm text-gray-600 mb-4">
            選擇要指派給此資源的權限標籤（可多選）：
          </p>
          <div className="space-y-2">
            {tags.filter(t => t.is_active !== false).length === 0 ? (
              <div className="text-center py-4 text-gray-500">沒有可用的權限標籤</div>
            ) : (
              tags.filter(t => t.is_active !== false).map((tag) => (
                <label
                  key={tag.id}
                  className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition ${
                    editingResourceTags.includes(tag.name)
                      ? 'border-purple-500 bg-purple-50'
                      : 'border-gray-200 hover:bg-gray-50'
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={editingResourceTags.includes(tag.name)}
                    onChange={() => toggleEditingTag(tag.name)}
                    className="w-4 h-4 text-purple-600 rounded"
                  />
                  <span
                    className="px-3 py-1 rounded-full text-sm text-white font-medium"
                    style={{ backgroundColor: tag.color || '#3B82F6' }}
                  >
                    {tag.name}
                  </span>
                  {tag.description && (
                    <span className="text-sm text-gray-500">{tag.description}</span>
                  )}
                </label>
              ))
            )}
          </div>
        </div>

        {/* Modal Footer */}
        <div className="p-6 border-t bg-gray-50 flex justify-between items-center">
          <div className="text-sm text-gray-500">
            已選擇 {editingResourceTags.length} 個標籤
          </div>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-100"
            >
              取消
            </button>
            <button
              onClick={saveMultiTagEditing}
              disabled={resourceSaving}
              className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
            >
              {resourceSaving ? '儲存中...' : '儲存'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MultiTagModal;
